import { CreateElement } from 'vue';
import { Store } from 'vuex';
import { container } from '../../../container';
import { DEPENDENCIES } from '../../../container/dependencies.const';
import { FacetsGroupConfig } from '../../../models';
import { GETTERS_KEYS, RootStoreState } from '../../../store';
import { Dictionary } from '../../../utils';
import FacetsGroup from './facets-group.vue';

export default {
  functional: true,
  render(createElement: CreateElement) {
    const store = container.get<Store<RootStoreState>>(DEPENDENCIES.Store);
    const facetsGroups: Dictionary<FacetsGroupConfig> = store.getters[GETTERS_KEYS.config.facetsGroups];
    return Object.entries<FacetsGroupConfig>(facetsGroups)
      .filter(([, facetGroupConfig]) => facetGroupConfig.templateSlots.panel !== null)
      .map(([groupId, facetGroupConfig]) =>
        createElement(FacetsGroup, {
          slot: facetGroupConfig.templateSlots.panel,
          props: {
            key: `facets-group-${ groupId }`,
            groupId
          }
        }));
  }
} as any;
